 
    import { Prop } from 'vue-property-decorator';  
    import { Options, Vue  } from "vue-class-component";   
     
    import Multiselect from '@vueform/multiselect'

    @Options({
        name: "ListaCampoForm",
        components: {  Multiselect },  
    }) 
    export default class  ListaCampoForm extends Vue {  
        
        @Prop( ) readonly campos!: any  
        @Prop( ) readonly formulario!: any  
        @Prop( ) readonly disabled!: any  

        
        public async  buscarPublicaco( query , api ){
            if(query){
                const response =  await api.service[api.method]( query );
                return response.data.map((item) => {
                    const label = typeof api.label === 'function' ? api.label(item) : item[api.label];
                    return { value: item[api.id], label }
                })
            }
        }

    } 
